/**
 * Estado de execução do serviço de uma esteira (at-46, ADR 0021).
 * PAUSADA = serviço inacabado: o veículo saiu da esteira sem concluir e pode voltar para retomar.
 */
export type AtividadeEstado = 'PENDENTE' | 'EM_ANDAMENTO' | 'PAUSADA' | 'CONCLUIDA';

export interface AtividadeCarro {
  id: string;
  carId: string;
  /** Legado (esteiras por chave). O backend não grava mais — usar `esteiraId`. */
  status?: string;
  esteiraId?: string;
  esteira?: { id: string; chave?: string; nome: string; cor: string; sistema?: boolean };
  statusLabel?: string;
  order: number | null;
  isActive: boolean;
  removedAt: string | null;
  createdById: string | null;
  createdAt: string;
  updatedAt: string;

  // at-46 — estado de execução do serviço.
  estado?: AtividadeEstado;
  estadoAtualizadoEm?: string | null;
  pausaObservacao?: string | null;
  pausadoPor?: { id: string; fullName: string | null; username: string | null } | null;
  concluidoEm?: string | null;
  concluidoPor?: { id: string; fullName: string | null; username: string | null } | null;
}

/** Serviço em aberto de um veículo, como as listagens de carros o expõem (at-46). */
export interface ServicoInacabado {
  esteiraId: string;
  esteiraNome: string | null;
  estado: AtividadeEstado;
  pausadoEm: string | null;
  pausadoPorId: string | null;
  pausadoPorNome: string | null;
  observacao: string | null;
  /**
   * at-134 (ADR 0065): o motivo da parada escolhido no catálogo — `observacao` passou a ser o
   * DETALHE dele. Nulo em pausa anterior à at-134 ou encerrada pelo sistema. Opcional para a tela
   * sobreviver a um backend anterior à entrega.
   */
  motivoParada?: { id: string; nome: string } | null;
}

/** Rótulos exibidos ao usuário para cada estado (sem emoji — regra do projeto). */
export const ATIVIDADE_ESTADO_LABEL: Record<AtividadeEstado, string> = {
  PENDENTE: 'Prevista',
  EM_ANDAMENTO: 'Em andamento',
  PAUSADA: 'Inacabado',
  CONCLUIDA: 'Realizada',
};

/** Serviço em aberto = começou e ainda não foi concluído (em andamento ou inacabado). */
export const isServicoEmAberto = (estado?: AtividadeEstado | null): boolean =>
  estado === 'EM_ANDAMENTO' || estado === 'PAUSADA';
